import { Box, Text, HStack, Flex, AspectRatio } from '@chakra-ui/react'
import Image from 'next/image'
import Link from 'next/link'
import BenefitMobile from './benefit-mobie'

const ProductCard02 = () => {
  const productData = {
    titleJP: '促进肝脏健康、保护肾脏功能',
    titleEN: 'Promote liver health and protect kidney function',
    subTitle:
      '平稳尿酸、轻松关节 / Stabilize uric acid, ease joints discomfort',
    descJP: `抑制尿酸合成酶的活性，降低体内尿酸，舒缓关节，抑制尿酸合成或促进其代谢来降低血液中的尿酸含量，减轻关节炎症和疼痛，减少结石形成的风险，影响脂肪代谢相关酶类的活性，进而调控血脂水平。`,
    descEN: `Regulate uric acid synthase to lower uric acid levels in the body, relieve joint discomfort, and enhance metabolism to reduce uric acid in the blood. This helps alleviate inflammation and pain, lower the risk of stone formation, and influence fat metabolism enzymes to regulate lipid levels.`,
    imageUrl:
      'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/item-2-1734075592408.png'
  }

  const benefitData = [
    {
      ratio: 500 / 212,
      imageUrl:
        'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/item2-1-1731602213793.png'
    },
    {
      ratio: 558 / 216,
      imageUrl:
        'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/item2-2-1731602213794.png'
    },
    {
      ratio: 502 / 212,
      imageUrl:
        'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/item2-3-1731602213794.png'
    }
  ]

  return (
    <Flex
      flexDir={{
        base: 'column-reverse',
        lg: 'row'
      }}
      justifyContent="space-between"
      pt={{
        base: '20px',
        lg: '105px'
      }}
      pb="80px"
      gap={5}
      id="uric-acid-control"
    >
      <Box
        w={{
          base: '100%',
          lg: '60%'
        }}
      >
        {/* Title and Subtitle */}
        <Box
          w="100%"
          maxW={{
            base: '100%',
            lg: '650px'
          }}
        >
          <Text textStyle="supplementProductCardTitleJP">
            {productData.titleJP}
          </Text>

          <Text textStyle="supplementProductCardTitleEN" mt={1}>
            {productData.titleEN}
          </Text>

          <Text
            textStyle="supplementProductCardSubTitle"
            bg="#9cb25a"
            w={{
              base: 'auto',
              md: 'max-content'
            }}
            mt={5}
            color="white"
            px={2}
            py={1}
          >
            {productData.subTitle}
          </Text>

          <Text textStyle="supplementProductCardDescJP" mt={5}>
            {productData.descJP}
          </Text>

          <Text textStyle="supplementProductCardDescEN" mt={5}>
            {productData.descEN}
          </Text>
        </Box>

        {/* Benefits */}
        <Box w="100%" mt={5}>
          <AspectRatio
            ratio={1540 / 216}
            w="100%"
            display={{
              base: 'none',
              md: 'block'
            }}
          >
            <Image
              src={
                'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/be-2-1731438361789.png'
              }
              alt="traditional item"
              fill
            />
          </AspectRatio>

          <Box
            display={{
              base: 'block',
              md: 'none'
            }}
          >
            <BenefitMobile items={benefitData} />
          </Box>
        </Box>

        {/* Buy Button */}
        <HStack
          justifyContent={{
            base: 'flex-start',
            md: 'flex-start'
          }}
          alignItems="center"
          gap={4}
          mt={5}
        >
          <Link href="https://habbit.sg/products/health-plus-kampo-uric-acid-control-90s">
            <AspectRatio
              ratio={1537 / 864}
              w={{
                base: '120px',
                sm: '120px',
                md: '140px',
                lg: '160px',
                xl: '160px'
              }}
              _hover={{
                opacity: 0.7
              }}
              mt={3}
            >
              <Image
                src={
                  'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/buy-now-btn-1714038035225.png'
                }
                alt="buy now btn"
                fill
              />
            </AspectRatio>
          </Link>

          <Box
            w={{
              base: '134px',
              xl: '134px'
            }}
            mt={2}
          >
            <AspectRatio ratio={67 / 32} w="100%">
              <Image
                src={
                  'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/cer-2-1731437893679.png'
                }
                alt="traditional item"
                fill
              />
            </AspectRatio>
          </Box>
        </HStack>
      </Box>

      <Box
        w={{
          base: '100%',
          lg: '60%'
        }}
        ml={{
          base: '0'
        }}
      >
        <AspectRatio ratio={1296 / 1334} w="100%">
          <Image src={productData.imageUrl} alt={productData.titleEN} fill />
        </AspectRatio>
      </Box>
    </Flex>
  )
}

export default ProductCard02
